// eslint-disable-next-line
export default {
    // Auth
    "auth.login": "Anmelden",
    "auth.email": "E-Mail",
    "auth.password": "Passwort",
    "auth.enterEmail": "Geben Sie Ihre E-Mail-Adresse ein",
    "auth.enterPassword": "Geben Sie Ihr Passwort ein",
    "auth.loginButton": "Anmelden",
    "auth.loggingIn": "Anmeldung läuft...",
    "auth.loginTitle": "Systemanmeldung",
    "auth.loginDescription": "Geben Sie Ihre E-Mail und Ihr Passwort ein, um sich anzumelden",
    "auth.logout": "Abmelden",
    "auth.authError": "Anmeldefehler",

    // Common
    "common.loading": "Laden...",
    "common.save": "Speichern",
    "common.cancel": "Abbrechen",
    "common.delete": "Löschen",
    "common.edit": "Bearbeiten",
    "common.create": "Erstellen",
    "common.close": "Schließen",
    "common.confirm": "Bestätigen",
    "common.yes": "Ja",
    "common.no": "Nein",
    "common.search": "Suche",
    "common.filter": "Filter",
    "common.settings": "Einstellungen",
    "common.active": "Aktiv",
    "common.inactive": "Inaktiv",
    "common.blocked": "Gesperrt",
    "common.total": "Gesamt",
    "common.deleteUser": "Benutzer löschen",
    "common.resetPassword": "Passwort zurücksetzen",
    "common.confirmDelete": "Löschen bestätigen",
    "common.deleteConfirmText": "Sind Sie sicher, dass Sie diesen Benutzer löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",

    // Roles
    "role.admin": "Administrator",
    "role.teacher": "Lehrer",
    "role.student": "Schüler",

    // Navigation
    "nav.dashboard": "Dashboard",
    "nav.users": "Benutzer",
    "nav.students": "Schüler",
    "nav.teachers": "Lehrer",
    "nav.courses": "Kurse",
    "nav.schedule": "Stundenplan",
    "nav.grades": "Noten",
    "nav.last_entry": "Letzter Zugriff",
    "nav.visits": "Besuche",
    "nav.never": "Nie",

    // Admin Dashboard
    "admin.title": "Admin-Dashboard",
    "admin.createTeacher": "Lehrer erstellen",
    "admin.systemUsers": "Systembenutzer",
    "admin.userManagement": "Verwaltung aller Systembenutzer",
    "admin.stats.admins": "Admins",
    "admin.stats.teachers": "Lehrer",
    "admin.stats.students": "Schüler",
    "admin.block": "Sperren",
    "admin.unblock": "Entsperren",

    // Teacher Dashboard
    "teacher.title": "Lehrer-Dashboard",
    "teacher.inviteStudent": "Schüler einladen",
    "teacher.myStudents": "Meine Schüler",
    "teacher.studentManagement": "Verwaltung der Schüler in Ihren Gruppen",
    "teacher.noStudents": "Sie haben noch keine Schüler",
    "teacher.inviteFirst": "Laden Sie Ihren ersten Schüler ein, indem Sie auf die Schaltfläche oben klicken",
    "teacher.addedOn": "Hinzugefügt am:",

    // Student Dashboard
    "student.title": "Schüler-Dashboard",
    "student.personalInfo": "Persönliche Informationen",
    "student.yourData": "Ihre Daten im System",
    "student.fullName": "Vollständiger Name",
    "student.role": "Rolle",
    "student.status": "Status",
    "student.courses": "Kurse",
    "student.coursesDesc": "Meine Kurse und Materialien",
    "student.schedule": "Stundenplan",
    "student.scheduleDesc": "Stundenplan der Lektionen",
    "student.grades": "Noten",
    "student.gradesDesc": "Meine Noten und Leistungen",
    "student.notifications": "Benachrichtigungen",
    "student.updates": "Neueste Updates und Ankündigungen",
    "student.welcome": "Willkommen im System!",
    "student.welcomeDesc":
        "Sie wurden erfolgreich im Schulverwaltungssystem registriert. Hier können Sie Ihre Kurse, Ihren Stundenplan und Ihre Noten einsehen.",
    "student.today": "Heute",
    "student.featuresInDev": "Funktionen in Entwicklung",
    "student.featuresDesc":
        "Zusätzliche Funktionen für Schüler (Kurse, Aufgaben, Noten) werden in zukünftigen Versionen des Systems hinzugefügt.",
    "student.info": "Information",

    // Password Change
    "password.change": "Passwort ändern",
    "password.new": "Neues Passwort",
    "password.confirm": "Passwort bestätigen",
    "password.required": "Sie müssen Ihr temporäres Passwort ändern, um fortzufahren",
    "password.enter": "Geben Sie ein neues Passwort für Ihr Konto ein",
    "password.minLength": "Mindestens 6 Zeichen",
    "password.repeat": "Wiederholen Sie das neue Passwort",
    "password.saving": "Wird gespeichert...",
    "password.success": "Passwort erfolgreich geändert",
    "password.error": "Fehler beim Ändern des Passworts",
    "password.minError": "Das Passwort muss mindestens 6 Zeichen lang sein",
    "password.mismatch": "Die Passwörter stimmen nicht überein",

    // Create Teacher Modal
    "createTeacher.title": "Lehrer erstellen",
    "createTeacher.description":
        "Geben Sie die Daten des neuen Lehrers ein. Eine Einladung wird an die angegebene E-Mail-Adresse gesendet.",
    "createTeacher.fullName": "Vollständiger Name",
    "createTeacher.fullNamePlaceholder": "Max Mustermann",
    "createTeacher.emailPlaceholder": "lehrer@schule.de",
    "createTeacher.creating": "Wird erstellt...",
    "createTeacher.success": "Lehrer erfolgreich erstellt",
    "createTeacher.error": "Fehler beim Erstellen des Lehrers",
    "createTeacher.exists": "Ein Benutzer mit dieser E-Mail-Adresse existiert bereits",

    // Invite Student Modal
    "inviteStudent.title": "Schüler einladen",
    "inviteStudent.description": "Geben Sie die Daten des neuen Schülers ein. Eine Einladung wird an die angegebene E-Mail-Adresse gesendet.",
    "inviteStudent.fullName": "Vollständiger Name",
    "inviteStudent.fullNamePlaceholder": "Peter Schmidt",
    "inviteStudent.emailPlaceholder": "schueler@schule.de",
    "inviteStudent.sending": "Einladung wird gesendet...",
    "inviteStudent.success": "Schüler erfolgreich eingeladen",
    "inviteStudent.error": "Fehler beim Einladen des Schülers",

    // System
    "system.title": "Fernunterrichtssystem",
    "system.error": "Systemfehler",
    "system.networkError": "Netzwerkfehler",
    "system.unauthorized": "Unbefugter Zugriff",
    "system.forbidden": "Zugriff verweigert",
    "system.notFound": "Nicht gefunden",
    // Trainers
    "messages.userDeleted": "Benutzer erfolgreich gelöscht",
    "messages.passwordReset": "Passwort zurückgesetzt und per E-Mail gesendet",
    "messages.deleteError": "Fehler beim Löschen des Benutzers",
    "messages.resetError": "Fehler beim Zurücksetzen des Passworts",

    "training.start": "Training starten",
    "trainings.title": "Trainingsmodule",
    "trainings.memory": "Gedächtnistraining",
    "trainings.memory.description": "Übungen zum Trainieren des Gedächtnisses von Schülern",
    "trainings.logic": "Logikaufgaben",
    "trainings.logic.description": "Logikaufgaben und Rätsel für Schüler",
    "trainings.back": "Zurück",
    "trainig.notImplemented": "Dieses Trainingsmodul ist noch nicht implementiert",
    // Mental arithmetics
    "trainings.mental": "Kopfrechnen",
    "trainings.mental.description": "Kopfrechentraining für Schüler",
    "mentalArithmetic": "Kopfrechnen",
    "trainer": "Trainer",
    "flashCards": "Lernkarten",
    "additionSubtraction": "Addition / Subtraktion",
    "multiplicationDivision": "Multiplikation / Division",
    "selectTrainerSettings": "Wählen Sie die Trainer-Einstellungen",
    "selectCardsSettings": "Wählen Sie die Lernkarten-Einstellungen",
    "selectMultiSettings": "Wählen Sie die Trainer-Einstellungen",
    "go": "Los",
    "theme": "Thema",
    "difficulty": "Schwierigkeit",
    "digits": "Stellen",
    "actionsCount": "Anzahl der Aktionen",
    "inputTime": "Zeit zur Antwort-Eingabe",
    "speed": "Geschwindigkeit",
    "start": "Start",
    "stop": "Stopp",
    "settings": "Einstellungen",
    "continue": "Fortsetzen",
    "simple": "Einfach",
    "brother": "Bruder",
    "friend": "Freund",
    "friendBrother": "Freund + Bruder",
    "transitions": "Übergänge",
    "allThemes": "Alle Themen",
    "multiplication": "Multiplikation",
    "division": "Division",
    "squaring": "Quadrieren",
    "performExercise": "Führen Sie die Übung aus",
    "yourAnswer": "Ihre Antwort:",
    "correct": "Richtig",
    "incorrect": "Falsch",
    "answer": "Antwort",
    "sec": "Sek",
    "multiplier": "Multiplikator",
    "divisor": "Divisor",
    "any": "Beliebig",
    "multiplicationTable": "Einmaleins",
    "byMultiplicationTable": "Nach dem Einmaleins",
    "resetAllSettings": "Alle Einstellungen zurücksetzen und die Seite neu laden?",
    "difficulties": {
        "0-4": "0-4",
        "0-5": "0-5",
        "0-6": "0-6",
        "0-7": "0-7",
        "0-8": "0-8",
        "0-9": "0-9",
        "4": "4",
        "3": "3",
        "2": "2",
        "1": "1",
        "9": "9",
        "8": "8",
        "7": "7",
        "6": "6",
        "5": "5",
        "50Plus": "50 +",
        "50Minus": "50 -",
        "100Plus": "100 +",
        "100Minus": "100 -"
    },
    "multiDifficulties": {
        "multiplicationTable": "Einmaleins",
        "2x1": "II x I",
        "3x1": "III x I",
        "2x2": "II x II",
        "4x1": "IIII x I",
        "3x2": "III x II",
        "base50": "Basis 50",
        "base100": "Basis 100",
        "base200": "Basis 200",
        "byMultiplicationTable": "Nach dem Einmaleins",
        "2div1": "II / I",
        "3div1": "III / I",
        "4div1": "IIII / I",
        "2div2": "II / II",
        "3div2": "III / II",
        "4div2": "IIII / II",
        "4div3": "IIII / III",
        "2-10": "2-10",
        "on5": "auf 5",
        "11-19": "11-19",
        "20-30": "20-30",
        "30-70": "30-70",
        "80-120": "80-120"
    },
    "multiThemes": {
        "multiplication": "Multiplikation",
        "division": "Division",
        "squaring": "Quadrieren"
    },
    "cardsDifficulties": {
        "0-4": "0-4",
        "0-9": "0-9"
    }
}